import React, { useState } from 'react';
import MouseLightEffect from './MouseLightEffect';
import { useTrack } from '../analytics/TrackingContext';

function GastoMensualCombustible({ setResultado, nombreVehiculo, setNombreVehiculo }) {
  const { trackEvent } = useTrack();
  const [consumoCombustible, setConsumoCombustible] = useState('');
  const [distanciaMensual, setDistanciaMensual] = useState('');
  const [precioLitro, setPrecioLitro] = useState('');
  const [resultado, setResultadoLocal] = useState(null);
  const [animarResultado, setAnimarResultado] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [editandoNombre, setEditandoNombre] = useState(true);
  const [nombreTemporal, setNombreTemporal] = useState('');

  const confirmarNombre = () => {
    if (nombreTemporal.trim()) {
      setNombreVehiculo(nombreTemporal.trim());
      setEditandoNombre(false);
    }
  };

  const calcularGasto = () => {
    if (!consumoCombustible || !distanciaMensual || !precioLitro) {
      setErrorMessage('Por favor, introduce todos los datos.'); // Mostrar mensaje de error
      setResultadoLocal(null); // Asegurar que no hay resultado previo
      setResultado(null); // Limpiar el estado del padre también
      return; // Salir de la función si falta algún dato
    }

    const gasto = (parseFloat(consumoCombustible) * parseFloat(distanciaMensual) * parseFloat(precioLitro)) / 100;
    setResultadoLocal(gasto); // Actualizar el resultado local
    setResultado(gasto); // Enviar el resultado al componente padre
    setAnimarResultado(true); // Activar la animación
    setErrorMessage(''); // Limpiar el mensaje de error si se calcula correctamente
    trackEvent('calculation', 'gasto_combustible');
  };

  return (
    <MouseLightEffect>
    <div className="section-container combustible">
      {editandoNombre ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
          <label htmlFor="nombre_gas_input" style={{ whiteSpace: 'nowrap', fontSize: '0.85rem' }}>Introduce el nombre del VC</label>
          <input
            id="nombre_gas_input"
            type="text"
            value={nombreTemporal}
            onChange={(e) => setNombreTemporal(e.target.value)}
            placeholder="Nombre VC"
            onKeyDown={(e) => { if (e.key === 'Enter') confirmarNombre(); }}
            style={{ flex: 2, minWidth: '180px' }}
          />
          <button className="calc" onClick={confirmarNombre} style={{ padding: '6px 14px', fontSize: '1.2rem', lineHeight: 1 }}>+</button>
        </div>
      ) : (
        <div style={{ textAlign: 'center', marginBottom: '8px' }}>
          <button className="reset-button" style={{ fontSize: '0.8rem', padding: '4px 10px' }} onClick={() => { setNombreTemporal(nombreVehiculo); setEditandoNombre(true); }}>Cambiar Nombre del Vehículo</button>
        </div>
      )}
      <h2>Coste de Combustible</h2>
      {nombreVehiculo && !editandoNombre && <h4 style={{ textAlign: 'center', margin: '4px 0 12px', fontStyle: 'italic' }}>{nombreVehiculo}</h4>}
      
      <div className="input">
        <label htmlFor="consumogas_input">Consumo del Vehículo (Litros/100 Km): </label>
        <input
          id="consumogas_input"
          type="number"
          value={consumoCombustible}
          onChange={(e) => setConsumoCombustible(e.target.value)}
          placeholder="Ej: 8"
          min={0}
        />
      </div>
      
      <div className="input">
        <label htmlFor="dist_gas_input">Distancia Recorrida (Km): </label>
        <input
          id="dist_gas_input"
          type="number"
          value={distanciaMensual}
          onChange={(e) => setDistanciaMensual(e.target.value)}
          placeholder="Ej: 1000"
          min={0}
        />
      </div>

      <div className="input">
        <label htmlFor="precio_gas_input">Precio por Litro de Combustible (Euros): </label>
        <input
          id="precio_gas_input"
          type="number"
          value={precioLitro}
          onChange={(e) => setPrecioLitro(e.target.value)}
          placeholder="Ej: 1.5"
          min={0}
        />
      </div>

      <div className="button">
        <button className="calc" onClick={calcularGasto}>Calcular Gasto</button>
      </div>

      {/* Mostrar mensaje de error si falta algún dato */}
      {errorMessage && (
          <div className="error-message" role="alert" aria-live="assertive">
          <p>{errorMessage}</p>
        </div>
      )}

      {resultado !== null && (
          <div className={`res ${animarResultado ? 'resultado-animado' : ''}`} aria-live="polite" aria-atomic="true">
          <p>Gasto mensual en combustible:</p>
          <p><strong>{resultado.toFixed(2)} Euros</strong></p>
          <div className="icon-container">
            <img src={`${process.env.PUBLIC_URL}/images/manguera-de-combustible01.png`} alt="Icono de Potencia" className="manguera-de-combustible" />
          </div>
        </div>
      )}
    </div>
    </MouseLightEffect>
  );
}

export default GastoMensualCombustible;


